import React, { Component, useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './congelacao.action';
import * as commonActions from '../../../../app/common/common.action';
import * as editorActions from '../../editor/editor.action';
import { acessoPermitido } from '../../../../acessos.seguranca';
import * as acessos from '../../../../acessos.const.util';
import * as editor from '../../editor/editor.util';
import { verificarPlainTextMudou } from '../../editor/editor.util';
import CongelacaoPage from './congelacao.page';
import { LOCAL_STORAGE_USUARIO } from '../../../../localStorage.util';
import WebapiCommon from '../../../../app/common/util/webapi.common';
import InconformidadeContainer from '@common/inconformidade/inconformidade.container';
import CongelacaoAPI from './congelacao.api';
import { errors } from '../../../error/erros';
import ModalConfirmar from '@common/modalConfirmar/modalConfirmar';
import { etapasEnum, statusEtapasEnum } from '@common/util/defaultValues';
import RequisicaoCongelacaoModal from '../../../main/listagem/modais/requisicaocongelacao/requisicao.congelacao.modal';
import { editorUrl } from '@constants/defaultValues';
import IntlMessage from "../../../../helpers/intlMessage";
import { useIntl } from 'react-intl';
import ModalEncaminhar from '@common/modalEncaminhar/modalEncaminhar';
import { useHistory } from 'react-router-dom';
import ExamesEmAbertoContainer from '../../etapas/macroscopia/operacoes/exames/exames.container';
import { urlImagemRadiologia } from '../etapas.common.util';

function CongelacaoContainer(props) {
  const history = useHistory();
  const [modalVisivel, setmodalVisivel] = useState(false);
  const [modalTitulo, setmodalTitulo] = useState('');
  const [modalConteudo, setmodalConteudo] = useState(undefined);
  const [modalSize, setmodalSize] = useState('lg');
  const [modalStyle, setmodalStyle] = useState(undefined);
  const [callbackAutorizar, setcallbackAutorizar] = useState(undefined);
  const [modalAutorizacaoLaudar, setmodalAutorizacaoLaudar] = useState(false);
  const [showModalCancelamento, setshowModalCancelamento] = useState(false);
  const [showModalConfirmarCancelamento, setshowModalConfirmarCancelamento] = useState(false);
  const [justificativaCancelar, setjustificativaCancelar] = useState('');
  const [timeoutResize, settimeoutResize] = useState(null);
  const [modalRequisicaoCongelacao, setmodalRequisicaoCongelacao] = useState(false);
  const [modalConfirmarMensagem, setmodalConfirmarMensagem] = useState('');
  const [modalConfirmarType, setmodalConfirmarType] = useState('confirm');
  const [modalConfirmarClick, setmodalConfirmarClick] = useState(() => { });
  const [modalConfirmar, setmodalConfirmar] = useState(false);
  const [modalEncaminhar, setModalEncaminhar] = useState(false)
  const [modalEncaminharType, setModalEncaminharType] = useState('ok');
  const [verificarTexto, setVerificarTexto] = useState(false);
  const [textoEditor, setTextoEditor] = useState('');
  const [existemImagemsRadiologia, setExistemImagensRadiologia] = useState(false);

  const intl = useIntl();

  useEffect(() => {
    window.addEventListener('message', ({ data }) => {
      if (data.value) {
        if (data.value.plain) {
          setTextoEditor(data.value.plain);
        }
      }
    });

    return () => {
      window.removeEventListener('message', null, true);
      props.commonActions.mudarStatusLaudoFaturado(false);
    }

  }, []);

  useEffect(() => {
    WebapiCommon.verificarSeExistemImagensRadiologica(props.detalhes.acNumber, props.detalhes.prontuario).then((resultado) =>{
      setExistemImagensRadiologia(resultado);
      if (props.editorInicializado && resultado){
        props.commonActions.showAlerta('alerta', <IntlMessage id="dashboards.examDetails.imagesVivaceConnect" />, 7000, '650px');
      }
    });
  }
  , [props.editorInicializado]);

  useEffect(() => {
    if (textoEditor !== undefined && verificarTexto) {
      setVerificarTexto(false);
      props.commonActions.showFadeCarregando(true);
      if (!textoEditor || textoEditor.trim() === '') {
        props.commonActions.showFadeCarregando(false);
        return showModal('6');
      }
      return laudar(false, false);
    }

  }, [textoEditor, verificarTexto]);


  function translate(key) {
    return intl.formatMessage({ id: key });
  }

  function useForceUpdate() {
    const [value, setValue] = useState(0);
    return () => setValue(value => value + 1);
  }

  const handleResize = useForceUpdate();

  useEffect(() => {
    props.commonActions.alterarVisibilidadeAbas({});
    document.title = 'Anatomia Patológica';
    try {
      editor.Inicializar(props, etapasEnum.CONGELACAO.toLowerCase());
    } catch (error) {
      let message = error.message;
      let title = '';
      let origin = `Etapa: ${etapasEnum.CONGELACAO}`;
      const code = 101;

      errors.map(err => {
        if (err.code === code) {
          title = err.title;
        }
        return err;
      });
      window.location.replace(
        `/error/${btoa(title)}/${btoa(message)}/${btoa(code)}/${btoa(origin)}/`
      );
    }

    const laudarEtapaRequest = {
      pendente: true,
      notificacaoCancer: false,
      exameId: props.detalhes.exameId,
      medicoSolicitante: props.detalhes.idSolicitante,
      medicoEtapa: props.editor.medExecutante
    };

    props.commonActions.argumentosSalvarEtapaLaudo(laudarEtapaRequest);

    let etapa = props.detalhes.etapas.find(
      el => el.etapa.toLowerCase() === etapasEnum.CONGELACAO.toLowerCase()
    );
    props.actions.congelacaoFinalizada(
      etapa.status === statusEtapasEnum.REALIZADO
    );
    window.addEventListener('resize', handleResize);

    return () => {
      editor.finalizar(props.commonActions);
      settimeoutResize(null);
    }

  }, []);

  useEffect(() => {
    if (
      props.visibilidadeAutotexto ||
      props.visibilidadeLaudosAnteriores ||
      props.visibilidadeListagemAnexo ||
      props.visibilidadeListaLaminas
    ) {
      if (!visibilidade) {
        setvisibilidade(true);
      }
    }
  }, [props.congelacao]);


  function cancelarCongelacao() {
    props.commonActions.showFadeCarregando(true);
    const listagem = [...props.listagem];
    const listagemIndex = listagem.findIndex(
      (item) => item.laudo === props.detalhes.laudo
    );
    if (listagemIndex >= 0) {
      listagem[listagemIndex].dataLiberacao = '';
      listagem[listagemIndex].isLaudoLiberado = false;
      listagem[listagemIndex].isLiberadoParcial = false;
      listagem[listagemIndex].isLiberadoTotal = false;
      props.commonActions.preencherListagem(listagem);
    }
    CongelacaoAPI.cancelamentoCongelacao(
      props.detalhes.laudo,
      state.justificativaCancelar
    ).then(res => {
      WebapiCommon.obterStatusEtapasLaudo(props.detalhes.laudo).then(
        etapas => {
          props.commonActions.atualizarStatusDasEtapasDoLaudo(
            etapas,
            props.detalhes.laudo
          );
          props.commonActions.showEditor(false);
          props.commonActions.showFadeCarregando(false);
          setshowModalCancelamento(!showModalCancelamento);

          _fechar();
        }
      );
    });
  }

  function _fechar() {
    history.goBack();
    //props.commonActions.atualizarDetalhes(undefined);
    props.commonActions.preenhcerHistoricoInconformidades(undefined);
    props.actions.collapedContainerExames(true);
    props.commonActions.atualizarLarguraEditor('100%');
    props.commonActions.showEditor(false);
  }

  function setJustificativa(texto) {
    setjustificativaCancelar(texto)
  }

  function cancelamentoCongelacao() {
    setshowModalCancelamento(true)
  }

  function cancelarEtapasPosteriores() {
    props.commonActions.showFadeCarregando(true);
    const listagem = [...props.listagem];
    const listagemIndex = listagem.findIndex(
      (item) => item.laudo === props.detalhes.laudo
    );
    if (listagemIndex >= 0) {
      listagem[listagemIndex].dataLiberacao = '';
      listagem[listagemIndex].isLaudoLiberado = false;
      listagem[listagemIndex].isLiberadoParcial = false;
      listagem[listagemIndex].isLiberadoTotal = false;
      props.commonActions.preencherListagem(listagem);
    }
    WebapiCommon.cancelarEtapasPosteriores(
      props.detalhes.laudo,
      props.etapaAtual,
      0,
      justificativaCancelar
    )
      .then((resp) => {
        if (resp.success) {
          props.commonActions.showAlerta(
            'sucesso',
            resp.data.mensagem,
            2000
          );

          WebapiCommon.obterStatusEtapasLaudo(props.detalhes.laudo).then(
            (etapas) => {
              props.commonActions.atualizarStatusDasEtapasDoLaudo(
                etapas,
                props.detalhes.laudo
              );
              props.commonActions.showEditor(false);
              props.commonActions.showFadeCarregando(false);
              setshowModalCancelamento(!showModalCancelamento);
              setshowModalConfirmarCancelamento(!showModalConfirmarCancelamento);
              _fechar();
            }
          )
        }
        else {
          props.commonActions.showFadeCarregando(false);
          props.commonActions.showAlerta(
            'erro',
            <IntlMessage id="dashboards.examDetail.unableCancelSteps" />,
            2000
          );
          setshowModalCancelamento(!showModalCancelamento);
          setshowModalConfirmarCancelamento(!showModalConfirmarCancelamento);

        }
      })
      .catch((error) => {
        props.commonActions.showFadeCarregando(false);
        props.commonActions.showAlerta(
          'erro',
          translate("dashboards.examDetail.unableCancelSteps"),
          2000
        );
        setshowModalCancelamento(!showModalCancelamento);
        setshowModalConfirmarCancelamento(!showModalConfirmarCancelamento);
      });
  }


  function alterarFullscreen() {
    props.commonActions.preencherAtalho('ctrl+alt+f10');
  }

  function showModal(index) {
    let componente = undefined;
    let style = {};
    let size = 'lg';
    let titulo = '';

    new Promise(resolve => {
      switch (index) {
        case '4':
          style = { maxWidth: '1000px' };
          componente = (
            <InconformidadeContainer
              intl={props.intl}
              altura={window.innerHeight - 200}
              funcFechar={() => {
                closeModal();
                fechar();
              }}
              etapa={etapasEnum.CONGELACAO}
            />
          );
          resolve(
            resolveShowModal(
              componente,
              `${translate('dashboards.examDetails.noncomplianceReport')} ${props.detalhes.laudo}`,
              style
            )
          );
          setmodalVisivel(true)
          break;
        case '5':
          setmodalConfirmarMensagem(translate("dashboards.examDetail.wasNotTypedMorphology"));
          setmodalConfirmarType('ok');
          setmodalConfirmarClick(() => {
            fecharModalConfirmar();
          });
          setmodalConfirmar(true);
        case '6':
          setmodalConfirmarMensagem(translate("dashboards.examDetail.notTyped"));
          setmodalConfirmarType('ok');
          setmodalConfirmarClick(() => {
            fecharModalConfirmar();
          });
          return setmodalConfirmar(true);
        case '7':
          componente = <ExamesEmAbertoContainer />;
          titulo = intl.formatMessage({ id: "dashboards.examDetails.openExamReport" });
          setmodalConteudo(componente);
          setmodalTitulo(titulo);
          setmodalVisivel(true);
          setmodalSize(size);
          break;
        default:
          resolve(resolveShowModal(undefined));
          break;
      }
    });
  }

  function resolveShowModal(componente, titulo, style) {
    setmodalConteudo(componente);
    setmodalTitulo(titulo);
    setmodalStyle(style);
  }

  function closeModal() {
    setmodalVisivel(false)
  }

  function toggleModalRequisicaoCongelacao() {
    setmodalRequisicaoCongelacao(!modalRequisicaoCongelacao)
  }

  function fecharModalConfirmar() {
    setmodalConfirmar(!modalConfirmar)
  };

  function verificaEditor() {
    props.commonActions.showFadeCarregando(true);
    const frame = document.getElementById('iframe-editor');

    if (frame !== null) {
      frame.contentWindow.postMessage(
        {
          method: 'recuperarTextoRtfAndPlainText',
          urlHost: editorUrl,
          args: {
            action: 'getPlainText'
          }
        },
        editorUrl
      );
    }

    setTimeout(() => {
      props.commonActions.showFadeCarregando(false);
      return setVerificarTexto(true);
    }, 200);

  }

  const encaminharSegundaOpiniao = () => {
    setModalEncaminhar(!modalEncaminhar)
  }

  const fecharModalEncaminhar = () => {
    setModalEncaminhar(!modalEncaminhar);
  };

  function construirBotoes() {
    let botoes = [];

    botoes.push({
      backgroundColor: '#4375A3',
      className: 'mv-basico-imprimir',
      color: '#ffffff',
      texto: props.intl.formatMessage({ id: 'dashboards.reports.printOut' }),
      onClick: () => editor.Imprimir(props.commonActions)
    });

    botoes.push({
      backgroundColor: '#3f8642',
      label: '2',
      color: '#ffffff',
      texto: props.intl.formatMessage({ id: 'dashboards.referral.referral' }),
      onClick: () => encaminharSegundaOpiniao(),
    });

    if (acessoPermitido(props.usuario, acessos.ExamesEmAberto) && existemImagemsRadiologia) {
      botoes.push({
        backgroundColor: '#3c5d80',
        className: 'fas fa-eye',
        // label: 'Imagens',
        color: '#ffffff',
        texto: intl.formatMessage({ id: 'Vivace Connect' }),
        onClick: () => {
          urlImagemRadiologia(props.commonActions, props.detalhes.acNumber, props.detalhes.prontuario);
        },
      });
    }

    if (acessoPermitido(props.usuario, acessos.ExamesEmAberto)) {
      botoes.push({
        backgroundColor: '#17a2b8',
        className: 'fas fa-flask',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetails.openExams' }),
        totalizador: props.quantidadeLaudosEmAberto,
        onClick: () => {
          showModal('7');
        }
      });
    }

    if (
      acessoPermitido(
        props.usuario,
        acessos.AdicionarBlocoseLaminasCongelacao
      ) &&
      !props.congelacaoFinalizada &&
      !props.exameFinalizado
    ) {
      botoes.push({
        className: 'fas fa-igloo',
        backgroundColor: '#f44336',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetails.freezingRequest' }),
        onClick: () => {
          toggleModalRequisicaoCongelacao();
        }
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.NaoConformidades) &&
      !props.congelacaoFinalizada &&
      !props.exameFinalizado
    ) {
      botoes.push({
        className: 'fas fa-exclamation-circle',
        backgroundColor: '#4caf50',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetail.Unconformities' }),
        onClick: () => {
          showModal('4');
        }
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.Congelacao) &&
      acessoPermitido(props.usuario, acessos.Concluir) &&
      !props.congelacaoFinalizada &&
      !props.exameFinalizado &&
      !props.visibilidadeLaudosAnteriores
    ) {
      botoes.push({
        backgroundColor: '#3f8642',
        className: 'fas fa-save',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetail.laud' }),
        atalho: 'CTRL+ALT+L',
        onClick: () => {
          verificaEditor();
        }
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.Congelacao) &&
      acessoPermitido(props.usuario, acessos.ConcluirPendente) &&
      !props.congelacaoFinalizada &&
      !props.exameFinalizado
    ) {
      botoes.push({
        backgroundColor: '#b81717',
        className: 'far fa-save',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetail.laudPendent' }),
        onClick: () => {
          laudar(true, false);
        }
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.Congelacao) &&
      acessoPermitido(props.usuario, acessos.ConcluirConferencia) &&
      !props.congelacaoFinalizada &&
      !props.exameFinalizado
    ) {
      botoes.push({
        backgroundColor: '#b81717',
        className: 'fas fa-file-signature',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetail.laudLecturer' }),
        // atalho: 'CTRL+ALT+P',
        onClick: () => {
          laudar(false, false, true);
        },
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.CancelamentoCongelacao) &&
      props.congelacaoFinalizada //&&
      // !props.exameFinalizado
    ) {
      botoes.push({
        backgroundColor: '#b81717',
        className: 'mv-basico-cancelar',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetail.Cancellation' }),
        atalho: 'CTRL+ALT+N',
        onClick: () => {
          setshowModalConfirmarCancelamento(true);
        }
      });
    }

    botoes.push({
      backgroundColor: '#bbbbbb',
      label: 'F',
      color: '#ffffff',
      texto: props.intl.formatMessage({ id: 'dashboards.examDetail.close' }),
      onClick: () => {
        fechar();
      }
    });

    return botoes;
  }

  function laudar(pendente, concluir, conferencia = false) {
    const usuarioLocal = JSON.parse(
      localStorage.getItem(LOCAL_STORAGE_USUARIO)
    );

    if (!usuarioLocal.medicoId && !pendente && !conferencia) {
      props.commonActions.showAlerta(
        'erro',
        <IntlMessage id="dashboards.examDetail.onlyDoctors" />,
        2000
      );
      return;
    }
    let laudarEtapaRequest = {
      ...props.laudarEtapaRequest,
      pendente: pendente,
      concluirLaudo: concluir,
      medicoEtapa: props.editor.medExecutante,
      medicoLogadoId: usuarioLocal.medicoId,
      laudarParaConferencia: conferencia
    };

    if (usuarioLocal.isResidente && !pendente && !conferencia) {

      setmodalAutorizacaoLaudar(true);

      setcallbackAutorizar({
        sucesso: medico_autorizou => {
          setmodalAutorizacaoLaudar(false)
          editarMedico(medico_autorizou);
          props.commonActions.argumentosSalvarEtapaLaudo(
            laudarEtapaRequest
          );
          editor.laudar(props.commonActions);
          props.commonActions.showAlerta(
            'sucesso',
            intl.formatMessage({ id: "dashboards.examDetail.reportSave" }),
            2000
          );
        },
        error: () => {
          props.commonActions.showAlerta(
            'erro',
            <IntlMessage id="dashboards.examDetail.notAllowed" />,
            2000
          );
        }
      })

    } else {
      props.commonActions.argumentosSalvarEtapaLaudo(laudarEtapaRequest);
      editor.laudar(props.commonActions);
      props.commonActions.showAlerta(
        'sucesso',
        intl.formatMessage({ id: "dashboards.examDetail.reportSave" }),
        2000
      );
    }
  }

  function fechar() {
    props.commonActions.changeFecharTela(true);
    verificarPlainTextMudou();
  }


  function alterarVisibilidadeAbas(propriedadeNoEstado) {
    const visibilidade = !props[propriedadeNoEstado];
    const larguraEditor = visibilidade
      ? 'calc(100% - 33.333333% - 10px)'
      : '100%';
    props.commonActions.alterarVisibilidadeAbas({
      [propriedadeNoEstado]: visibilidade
    });
    props.commonActions.atualizarLarguraEditor(larguraEditor);
  }
  return (
    <React.Fragment>
      <ModalEncaminhar
        toggleModalEncaminhar={() => setModalEncaminhar(!modalEncaminhar)}
        type={modalEncaminharType}
        showModalEncaminhar={modalEncaminhar}
        titulo={'Encaminhar'}
        mensagem={'Encaminhar'}
        confirmar={() => fecharModalEncaminhar()}
        laudo={props.detalhes.laudo}
        commonActions={props.commonActions}
      />
      <RequisicaoCongelacaoModal
        isOpen={modalRequisicaoCongelacao}
        toggle={() => toggleModalRequisicaoCongelacao()}
        laudo={props.detalhes.laudo}
      />
      <ModalConfirmar
        toggleModalConfirmar={() =>
          setmodalConfirmar(!modalConfirmar)
        }
        type={modalConfirmarType}
        showModalConfirmar={modalConfirmar}
        titulo={`${intl.formatMessage({ id: "dashboards.examDetail.headsUp" })}`}
        mensagem={modalConfirmarMensagem}
        confirmar={modalConfirmarClick}
      />
      <CongelacaoPage
        usuario={props.usuario}
        // inicio cancelamento
        showModalCancelamento={showModalCancelamento}
        toggleModalCancelamento={() => setshowModalCancelamento(!showModalCancelamento)}
        cancelarCongelacao={(e) => cancelarCongelacao(e)}
        // fim cancelamento
        modalVisivel={modalVisivel}
        modalTitulo={modalTitulo}
        modalConteudo={modalConteudo}
        modalSize={modalSize}
        modalStyle={modalStyle}
        closeModal={(e) => closeModal(e)}
        detalhes={props.detalhes}
        construirBotoes={construirBotoes()}
        acessoPermitido={acessoPermitido}
        altura={window.innerHeight - props.altura - 214}
        alterarFullscreen={(e) => alterarFullscreen(e)}
        modalAutorizacaoLaudar={modalAutorizacaoLaudar}
        callbackAutorizar={callbackAutorizar}
        fecharModalAutorizacao={() =>
          setmodalAutorizacaoLaudar(false)
        }
        congelacaoFinalizada={props.congelacaoFinalizada}
        justificativaCancelar={justificativaCancelar}
        setJustificativa={(e) => setJustificativa(e)}
        showModalConfirmacaoCancelamento={(e) => cancelamentoCongelacao(e)}
        modalIsOpen={showModalConfirmarCancelamento}
        toggleModalConfirmarCancelamento={() => setshowModalConfirmarCancelamento(!showModalConfirmarCancelamento)}
        cancelarEtapas={(e) => cancelarEtapasPosteriores(e)}
        alterarVisibilidadeAbas={(e) => alterarVisibilidadeAbas(e)}
        visibilidadeListaLaminas={props.visibilidadeListaLaminas}
        visibilidadeAutotexto={props.visibilidadeAutotexto}
        visibilidadeListagemAnexo={props.visibilidadeListagemAnexo}
        visibilidadeLaudosAnteriores={props.visibilidadeLaudosAnteriores}
        visibilidadeHistoricoLaudo={props.visibilidadeHistoricoLaudo}
        quantidadeLaudosAnteriores={props.quantidadeLaudosAnteriores}
      />
    </React.Fragment>
  );

}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    editorActions: bindActionCreators(editorActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    usuario: state.usuario,
    altura: state.commonReducer.altura,
    detalhes: state.commonReducer.detalhes,
    editor: state.editor,
    editorCarregado: state.commonReducer.editorCarregado,
    laudarEtapaRequest: state.commonReducer.laudarEtapaRequest,
    listagem: state.commonReducer.listagem,
    congelacaoFinalizada: state.congelacao.congelacaoFinalizada,
    exameFinalizado: state.commonReducer.exameFinalizado,
    visibilidadeListaLaminas: state.commonReducer.visibilidadeListaLaminas,
    visibilidadeAutotexto: state.commonReducer.visibilidadeAutotexto,
    visibilidadeLaudosAnteriores:
      state.commonReducer.visibilidadeLaudosAnteriores,
    visibilidadeListagemAnexo: state.commonReducer.visibilidadeListagemAnexo,
    visibilidadeHistoricoLaudo: state.commonReducer.visibilidadeHistoricoLaudo,
    quantidadeLaudosAnteriores: state.commonReducer.quantidadeLaudosAnteriores,
    etapaAtual: state.commonReducer.etapa.etapa,
    quantidadeLaudosEmAberto: state.commonReducer.quantidadeLaudosEmAberto,
    editorInicializado: state.commonReducer.editorInicializado
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CongelacaoContainer);



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/congelacao/congelacao.container.js